import type { RewardsStateModel } from '@ps/web-core-store';

import { TrackingCategory } from '../enums/index';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils/GAEvent';

// @TODO dimensions for boost and tier-up
export const rewardsImpression = (_tracking: TrackingContextValue, _data: RewardsStateModel) => {
  GAEvent({ action: 'Progress Seen' }, { category: TrackingCategory.Rewards });
};
